/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../../../teva/resizable/resizable.ts" />
/// <reference path="../../../teva/moveable/moveable.ts" />
/// <reference path="../../../teva/sortable/sortable.ts" />
/// <reference path="../../crm/main/main.ts" />

namespace OfficeGuy.Apps {
    interface WidgetPosition {
        Top: number;
        RightLeft: number;
    }

    export class Dashboards {
        static CurrentView: string;
        static DroppedLinkPosition: WidgetPosition;

        static PageLoad() {
            Dashboards.CurrentView = null;
            Dashboards.DroppedLinkPosition = null;
        }

        static LoadAjax($ContentContainer) {
            if ($ContentContainer.closest("td").length > 0)
                return false;
            var $Ajax = $ContentContainer.find(".og-ajax");
            if ($Ajax.length == 0)
                return false;

            var Method = $Ajax.data("ajax-method");
            var URL = $Ajax.data("ajax-url");
            if (Method != "GET") {
                alert("Method not supported: " + Method);
                return false;
            }

            var Data = $Ajax.data("ajax-data");

            $Ajax.remove();
            $
                (document.createElement('div')
                    .addClass("og-dashboards-loading-container"))
                .append(document.createElement('div').addClass('og-dashboards-loading'))
                .appendTo($ContentContainer);

            $.ajax({
                url: URL,
                data: JSON.stringify(Data),
                contentType: "application/json",
                type: Method,
                success: function (HTML) {
                    $ContentContainer.css("min-height", $ContentContainer.css("height")).hide().html(HTML);
                    Teva.SlideOrFade.Show($ContentContainer, 400, function () {
                        $ContentContainer.css("min-height", "");
                    });
                    $(document).trigger("OfficeGuy.AjaxLoaded", $ContentContainer);
                }
            });
            return true;
        }

        static LoadDashboard(View): void {
            if (Dashboards.CurrentView == View)
                return;

            Dashboards.CurrentView = View;
            $(".og-dashboards-buttons-desktop, .og-dashboards-editor-desktop, .og-dashboards-grid-desktop").toggleClass("hidden", View == "Mobile");
            $(".og-dashboards-buttons-mobile, .og-dashboards-editor-mobile, .og-dashboards-grid-mobile").toggleClass("hidden", View != "Mobile");

            if ($(".og-dashboards-editor").length == 0)
                return;

            $(".og-dashboards-editor-widgets:first > tr > td", Dashboards.GetCurrentEditor()).each(function () {
                Dashboards.AddWidget($(this), false, $(".og-dashboards-editor-widgetpreview:first", this).html());
            });
            Dashboards.DisableInputs($(".dashboards-widget-menu-defaultlink-body > div.hidden"));
            Dashboards.SetGridHeight();
        }

        static GetCurrentEditor() {
            if (Dashboards.CurrentView == "Mobile")
                return $(".og-dashboards-editor-mobile:first");
            else
                return $(".og-dashboards-editor-desktop:first");
        }

        static SetGridHeight() {
            var $Grid = $("> .og-dashboards-grid", Dashboards.GetCurrentEditor());
            var Height = 0;
            $Grid.find("> .og-dashboards-widget").each(function () {
                Height = Math.max(Height, $(this).position().top + $(this).outerHeight());
            });
            $Grid.height(Height + 200);
        }

        static UpdateInputsFromGrid(): void {
            $("> .og-dashboards-grid > .og-dashboards-widget", Dashboards.GetCurrentEditor()).each(function () {
                var $TempTD = $($(this).data("TD"));
                var $Widget = $(this);
                var Position_X = Math.round(parseInt($Widget.css(OfficeGuy.Common.IsRightToLeft() ? "right" : "left")));
                var Position_Y = Math.round($Widget.position().top);
                var Width = Math.round($Widget.width());
                var Height = Math.round($Widget.height());
                $TempTD.find(".Position_X").val(Position_X.toString());
                $TempTD.find(".Position_Y").val(Position_Y.toString());
                $TempTD.find(".Width").val(Width.toString());
                $TempTD.find(".Height").val(Height.toString());
            });
        }

        static UpdateExistingWidget($TD, NewContent): void {
            var $Widget = $($TD.data("Widget"));
            $Widget.find(":not(div.teva-resizable-resizer)").remove();
            $(NewContent).prependTo($Widget);
            Dashboards.LoadAjax($Widget.find('.sumit-dashboards-foldercontents'));
        }

        static AddWidget($TD, AutoPosition: boolean, WidgetContent: any): void {
            var Width = parseInt(<string>$TD.find(".Width").val());
            if (Width == 0)
                Width = parseInt($TD.attr("data-width-default"));

            var Height = parseInt(<string>$TD.find(".Height").val());
            if (Height == 0)
                Height = parseInt($TD.attr("data-height-default"));

            var Position: WidgetPosition = null;
            if (AutoPosition) {
                if (Dashboards.DroppedLinkPosition != null) {
                    if (Dashboards.GetUsedArea(Dashboards.GetUsedAreas(), Dashboards.DroppedLinkPosition.Top, Dashboards.DroppedLinkPosition.RightLeft, Width, Height) == null)
                        Position = Dashboards.DroppedLinkPosition;
                    Dashboards.DroppedLinkPosition = null;
                }
                if (Position == null)
                    Position = Dashboards.GetFreeLocation(Width, Height);

                $TD.find(".Position_Y").val(Position.Top.toString());
                $TD.find(".Position_X").val(Position.RightLeft.toString());
            }
            else
                Position = <WidgetPosition>{
                    Top: parseInt(<string>$TD.find(".Position_Y").val()),
                    RightLeft: parseInt(<string>$TD.find(".Position_X").val())
                };

            var $Widget = $
                (document.createElement('div')
                    .addClass("og-dashboards-widget")
                    .addClass("og-dashboards-widget-" + $TD.find(".Type").val())
                    .attr("data-minwidth", $TD.attr("data-width-min"))
                    .attr("data-maxwidth", $TD.attr("data-width-max"))
                    .attr("data-minheight", $TD.attr("data-height-min"))
                    .attr("data-maxheight", $TD.attr("data-height-max")))
                .data("TD", $TD[0])
                .css("width", Width)
                .css("height", Height)
                .css("top", Position.Top)
                .css(OfficeGuy.Common.IsRightToLeft() ? "right" : "left", Position.RightLeft)
                .append(WidgetContent)
                .appendTo($("> .og-dashboards-grid", Dashboards.GetCurrentEditor()));

            $TD.data("Widget", $Widget);
            Dashboards.LoadAjax($Widget.find('.sumit-dashboards-foldercontents'));

            Dashboards.UpdateWidgetEvents($Widget);

            if (AutoPosition)
                Dashboards.SetGridHeight();
        }

        static OpenWidgetEditor($Widget) {
            if ($Widget.data("IgnoreEditor") == "1")
                return;

            var $TD = $($Widget.data("TD"));

            var IsDeleted = false;
            var $Modal = OfficeGuy.Modals.Create({
                Title: OfficeGuy.Resources.GetString("CRM", "Edit"),

                Body: function (BodyContainer) {
                    $TD.children().appendTo(BodyContainer);
                },
                Buttons: [
                    $(document.createElement('button'))
                        .attr("type", "button")
                        .addClass("og-button-ui-action og-button-color-unframed")
                        .text(OfficeGuy.Resources.GetString("CRM", "Delete"))
                        .on("click", function () {
                            var WidgetDivClass = Dashboards.CurrentView == "Mobile" ? ".MobileWidgets" : ".DesktopWidgets";

                            var $Row = $TD.closest("tr");
                            OfficeGuy.Forms.NestedForm_Remove(WidgetDivClass, "Data" + WidgetDivClass, $Row.index());

                            $TD.data("Widget").remove();
                            $Row.remove();
                            IsDeleted = true;
                            Modals.Hide($Modal);
                            return true;
                        }),
                    $
                        (document.createElement('button')
                            .attr("type", "button")
                            .addClass("og-button-ui-action", "og-button-color-submit")
                            .setText(OfficeGuy.Resources.GetString("CRM", "Close"))
                        )
                        .on("click", function () {
                            Modals.Hide($Modal);
                            return true;
                        })
                ],
                EnterEvent: function () {
                    Modals.Hide($Modal);
                    return false;
                },
                HidingEvent: function () {
                    if (IsDeleted)
                        return;

                    OfficeGuy.Apps.Dashboards.FixMenuItemNames();
                    $(".modal-body", $Modal).children().appendTo($TD);

                    Dashboards.DisableInputs($TD.find(".dashboards-widget-menu-defaultlink-body > div.hidden"));

                    $('.modal-body', $Modal).empty();
                    OfficeGuy.CRM.Main.UpdateCustomFields($TD);
                    var Data = $TD.wrap("<form>").parent().serialize();
                    $TD.unwrap();

                    if ($TD.closest('tr').index() != 0) {
                        Data = Data.replace(new RegExp('Data.DesktopWidgets%5B' + $TD.closest('tr').index() + '%5D', 'g'), 'Data.DesktopWidgets%5B0%5D');
                        Data = Data.replace(new RegExp('Data.MobileWidgets%5B' + $TD.closest('tr').index() + '%5D', 'g'), 'Data.MobileWidgets%5B0%5D');
                    }
                    OfficeGuy.Apps.Dashboards.UpdateExistingWidget($TD, "<div class='loadingWidget'>בטעינה...</div>");

                    Common.AjaxRequest({
                        URL: "/dashboards/getupdatedwidget/",
                        ContentType: "application/x-www-form-urlencoded; charset=UTF-8",
                        ProcessData: false,
                        Data: Data,
                        SuccessMethod: function (Response) {
                            OfficeGuy.Apps.Dashboards.UpdateExistingWidget($TD, Response);
                        }
                    });
                    $('.modal-body', $Modal).children().appendTo($TD);
                }
            });

            return false;
        }

        static AddDashboardWidget(Subject): boolean {

            var Cancelled = false;
            var WidgetDivClass = Dashboards.CurrentView == "Mobile" ? ".MobileWidgets" : ".DesktopWidgets";

            var $Row = $(WidgetDivClass + " > tr:last");
            var $TD = $Row.find('> td');

            var $Modal = OfficeGuy.Modals.Create({
                Title: Subject,
                Body: function (BodyContainer) {
                    $TD.children().appendTo(BodyContainer);
                },
                Buttons: [
                    $
                        (document.createElement('button')
                            .attr("type", "button")
                            .addClass("og-button-ui-action", "og-button-color-unframed")
                            .setText(OfficeGuy.Resources.GetString("Modal", "Cancel")))
                        .on("click", function () {
                            Cancelled = true;
                            OfficeGuy.Modals.Hide($Modal);
                            return false;
                        }),
                    $
                        (document.createElement('button')
                            .attr("type", "button")
                            .addClass("og-button-ui-action", "og-button-color-submit")
                            .setText(OfficeGuy.Resources.GetString("CRM", "Save")))
                        .on("click", function () {
                            OfficeGuy.Modals.Hide($Modal);
                            Dashboards.FixMenuItemNames();
                            return false;
                        })
                ],
                EnterEvent: function () {
                    $(".og-button-ui-action.og-button-color-submit", $Modal).trigger("click");
                    return false;
                },
                HidingEvent: function () {
                    if (Cancelled) {
                        OfficeGuy.Forms.NestedForm_Remove(WidgetDivClass, "Data" + WidgetDivClass, $Row.index());
                        $Row.remove();
                        $('.modal-body', $Modal).empty();
                        return true;
                    }

                    $('.modal-body', $Modal).children().appendTo($TD);

                    Dashboards.DisableInputs($TD.find(".dashboards-widget-menu-defaultlink-body > div.hidden"));

                    $('.modal-body', $Modal).empty();
                    OfficeGuy.CRM.Main.UpdateCustomFields($TD);
                    var Data = $TD.wrap("<form>").parent().serialize();

                    $TD.unwrap();

                    if ($TD.closest('tr').index() != 0) {
                        Data = Data.replace(new RegExp('Data.DesktopWidgets%5B' + $TD.closest('tr').index() + '%5D', 'g'), 'Data.DesktopWidgets%5B0%5D');
                        Data = Data.replace(new RegExp('Data.MobileWidgets%5B' + $TD.closest('tr').index() + '%5D', 'g'), 'Data.MobileWidgets%5B0%5D');
                    }

                    Dashboards.AddWidget($TD, true, '<div class="loadingWidget">בטעינה...</div>');

                    Common.AjaxRequest({
                        URL: "/dashboards/getupdatedwidget/",
                        ContentType: "application/x-www-form-urlencoded; charset=UTF-8",
                        ProcessData: false,
                        Data: Data,
                        SuccessMethod: function (Response) {
                            Dashboards.UpdateExistingWidget($TD, Response);
                            Dashboards.UpdateInputsFromGrid();
                        }
                    });
                }
            });
            return false;
        }

        static GetUsedAreas() {
            var ToReturn = new Array();
            $("> .og-dashboards-grid > .og-dashboards-widget", Dashboards.GetCurrentEditor()).each(function () {
                var WidgetRightLeft;
                var WidgetTop = $(this).position().top;
                if (OfficeGuy.Common.IsRightToLeft())
                    WidgetRightLeft = parseInt($(this).css("right"));
                else
                    WidgetRightLeft = $(this).position().left;

                ToReturn.push({
                    Top: WidgetTop,
                    RightLeft: WidgetRightLeft,
                    Height: $(this).height(),
                    Width: $(this).width()
                });
            });
            return ToReturn;
        }
        static GetUsedArea(UsedAreas, Top, RightLeft, Width, Height) {
            for (var i = 0; i < UsedAreas.length; i++) {
                if (Top < UsedAreas[i].Top + UsedAreas[i].Height
                    && Top > UsedAreas[i].Top - Height
                    && RightLeft < UsedAreas[i].RightLeft + UsedAreas[i].Width
                    && RightLeft > UsedAreas[i].RightLeft - Width) {
                    return UsedAreas[i];
                }
            }
            return null;
        }
        static GetFreeLocation(Width: number, Height: number): WidgetPosition {
            var UsedAreas = Dashboards.GetUsedAreas();
            var ContainerWidth = $("> .og-dashboards-grid", Dashboards.GetCurrentEditor()).width();
            var ContainerHeight = $("> .og-dashboards-grid", Dashboards.GetCurrentEditor()).height();

            for (var Top = 0; Top <= ContainerHeight - Height; Top += 5) {
                for (var Right = 0; Right <= ContainerWidth - Width; Right += 5) {
                    var UsedArea = Dashboards.GetUsedArea(UsedAreas, Top, Right, Width, Height);
                    if (UsedArea == null) {
                        UsedArea = Dashboards.GetUsedArea(UsedAreas, Top + 5, Right, Width, Height);
                        if (UsedArea == null && Top != 0)
                            return <WidgetPosition>{ Top: Top + 5, RightLeft: Right };
                        return <WidgetPosition>{ Top: Math.round(Top), RightLeft: Math.round(Right) };
                    }
                    else
                        Right = UsedArea.RightLeft + UsedArea.Width;
                }
            }

            return null;
        }

        static UpdateWidgetEvents($Widget) {
            Teva.Moveable.Enable($Widget, {
                Container: $("> .og-dashboards-grid", Dashboards.GetCurrentEditor()),
                PreventOverClass: "> div",
                StepSize: 5,
                OnStop: function (Dragged, ThresholdPassed) {
                    Dashboards.UpdateInputsFromGrid();
                    Dashboards.SetGridHeight();
                    if (ThresholdPassed) {
                        $Widget.data("IgnoreEditor", "1")
                        setTimeout(function () {
                            $Widget.data("IgnoreEditor", "0");
                        }, 50);
                    }
                }
            });

            Teva.Resizable.Enable($Widget, {
                Container: $("> .og-dashboards-grid", Dashboards.GetCurrentEditor()),
                PreventOverClass: "> div",
                MinWidth: parseInt($Widget.attr("data-minwidth")),
                MaxWidth: parseInt($Widget.attr("data-maxwidth")),
                MinHeight: parseInt($Widget.attr("data-minheight")),
                MaxHeight: parseInt($Widget.attr("data-maxheight")),
                OnStart: function () {
                    $Widget.data("IgnoreEditor", "1");
                },
                OnStop: function () {
                    $Widget.data("IgnoreEditor", "0");
                    Dashboards.UpdateInputsFromGrid();
                    Dashboards.SetGridHeight();
                }
            });

            $Widget.on("click", function () {
                OfficeGuy.Apps.Dashboards.OpenWidgetEditor($(this));
                return false;
            });

            Dashboards.DisableSelection($Widget);
        }

        private static DisableSelection($Element) {
            $Element
                .attr("unselectable", "on")
                .css("user-select", "none")
                .on("selectstart", false);
        }

        static FixMenuItemNames(): void {
            $(".Widgets > tr").each(function (WidgetIndex) {
                $(".MenuItemsLinks > a", this).each(function () {
                    var OnClickText = $(this).attr("onclick");
                    $(this).attr("onclick", OnClickText.replace("MenuItems-00", "MenuItems-" + WidgetIndex));
                });

                $(".og-dashboards-widget-Menu-items", this).removeClass("MenuItems-00").addClass("MenuItems-" + WidgetIndex);
                $(".og-dashboards-widget-Menu-items > tr", this).each(function (MenuItemIndex) {
                    var $Inputs = $("input", this);
                    for (var i = 0; i < $Inputs.length; i++) {
                        var $Input = $($Inputs[i]);
                        if ($Input.attr("data-name") != null || $Input.attr("name") == null || $Input.attr("name").indexOf("nestedObject") == -1)
                            continue;
                        var FieldName = $Input.attr("name");
                        var Name = FieldName.substring(FieldName.indexOf("nestedObject.") + "nestedObject.".length);
                        $Input
                            .attr("name", "Data.Widgets[" + WidgetIndex + "].MenuItems[" + MenuItemIndex + "]." + Name)
                            .attr("id", "Data_Widgets[" + WidgetIndex + "]_MenuItems[" + MenuItemIndex + "]_" + Name)
                            .attr("data-name", Name);
                    }
                });
            });
        }
        static FixContainerWidgetChildWidgetsNames(): void {
            $(".Widgets > tr > td").each(function () {
                var WidgetIndex = $(this).closest("tr").index();
                var Widget = $(this).data("Widget");
                var $ChildWidgets = $(".og-buttonscolumn-container > .og-dashboards-widget", Widget);
                if ($ChildWidgets.length == 0)
                    return;
                $($ChildWidgets).each(function (ChildWidgetIndex) {
                    var ChildWidgetTD = $(this).data("TD");
                    var $Inputs = $("input,select", ChildWidgetTD);
                    for (var i = 0; i < $Inputs.length; i++) {
                        var $Input = $($Inputs[i]);
                        var FieldName = $Input.attr("name");
                        var Name = FieldName.substring(FieldName.lastIndexOf(".") + 1);
                        $Input
                            .attr("name", "Data.Widgets[" + WidgetIndex + "].ChildWidgets[" + ChildWidgetIndex + "]." + Name)
                            .attr("id", "Data_Widgets[" + WidgetIndex + "]_ChildWidgets[" + ChildWidgetIndex + "]_" + Name)
                            .attr("data-name", Name);
                    }
                });
            });
        }

        static Menu_ShowDefault($LI): boolean {
            var ModelID = $LI.parent().attr("data-id");
            var DataType = $LI.attr("data-type");

            $(".dashboards-widget-menu-defaultlink-header-" + ModelID + " > div").removeClass("og-button-color-submit").addClass("og-button-color-default");
            $LI.addClass("og-button-color-submit").removeClass("og-button-color-default");

            var $Widgets = $(".dashboards-widget-menu-defaultlink-body-" + ModelID + " > div");
            $Widgets.addClass("hidden");
            $(".dashboards-widget-menu-defaultlink-body-" + ModelID + " > div." + DataType).removeClass("hidden");

            Dashboards.DisableInputs($(".dashboards-widget-menu-defaultlink-body > div.hidden", $Widgets));
            Dashboards.EnableInputs($(".dashboards-widget-menu-defaultlink-body-" + ModelID + " > div." + DataType));

            return false;
        }

        static DisableInputs($Container) {
            $Container.find("input:not(:disabled), select:not(:disabled), textarea:not(:disabled)").data("dashboards-enable", "1").attr("disabled", "disabled");
        }
        static EnableInputs($Container) {
            $Container.find("input:disabled, select:disabled, textarea:disabled").filter(function () { return $(this).data("dashboards-enable") == "1"; }).data("dashboards-enable", null).attr("disabled", null);
        }

        static InitMenuItemsIndex(): void {
            Teva.Sortable.Enable($(".og-dashboards-widget-Menu-items"), {
                HandleSelector: ".icon-drag"
            });
        }

        static SchemaPicker_Selected($SchemaPicker): void {
            var SchemaID = $SchemaPicker.val();
            var $ViewPicker = $('input.viewpicker', $SchemaPicker.closest('.modal-body'));
            if ($ViewPicker.length > 0) {
                var ViewPickerInstance = Teva.SelectBox.GetInstance($ViewPicker);
                $ViewPicker.data("schemaid", SchemaID);
                ViewPickerInstance.ClearCache();
                ViewPickerInstance.ClearValue();
                if (SchemaID == 0)
                    ViewPickerInstance.Disable();
                else
                    ViewPickerInstance.Enable();
            }
            var $EntityPicker = $('input.entitypicker', $SchemaPicker.closest('.modal-body'));
            if ($EntityPicker.length > 0) {
                var EntityPickerInstance = Teva.SelectBox.GetInstance($EntityPicker);
                $EntityPicker.data("schemaid", SchemaID);
                EntityPickerInstance.ClearCache();
                EntityPickerInstance.ClearValue();
                if (SchemaID == 0) {
                    EntityPickerInstance.Disable();
                    $(".entitypickercontainer button").attr("disabled", "disabled");
                }
                else {
                    EntityPickerInstance.Enable();
                    $(".entitypickercontainer button").attr("disabled", null);
                }
            }
            var $Label = $(".og-dashboards-widget-text input", $SchemaPicker.closest('.modal-body'));
            if ($Label.length > 0)
                $Label.attr("placeholder", SchemaID == 0 ? "" : Teva.SelectBox.GetInstance($SchemaPicker).SelectedText).trigger("change");
        }
    }
}

$(document).on("Teva.PageLoad", function () {
    OfficeGuy.Apps.Dashboards.PageLoad();
});
